import { render, staticRenderFns } from "./passmant.vue?vue&type=template&id=2c6c60a6&scoped=true"
import script from "./passmant.vue?vue&type=script&lang=js"
export * from "./passmant.vue?vue&type=script&lang=js"
import style0 from "./passmant.vue?vue&type=style&index=0&id=2c6c60a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6c60a6",
  null
  
)

export default component.exports